<template>
  <div class="relative flex items-center">
    <span
      class="relative ml-3 hover:text-teal-700 cursor-pointer"
      @click="toggleFilters"
    >
      <font-awesome-icon
        :icon="['fas', 'sliders-h']"
        fixed-width
      ></font-awesome-icon>
      <span class="text-sm" v-text="i18n.button"></span>
    </span>
    <collapse-transition :duration="100">
      <div
        class="absolute mt-8 top-0 right-0 p-3 z-10 border rounded bg-white shadow-md text-sm min-w-sm"
        v-if="visible"
      >
        <div class="">
          <h2
            class="white-space-no-wrap pb-2 text-black font-bold"
            v-text="i18n.statuses"
          ></h2>
          <multiselect
            :options="statuses"
            v-model="statusesObj"
            :multiple="true"
            label="label"
            track-by="name"
            :placeholder="i18n.multiselect.placeholder"
            :selectLabel="i18n.multiselect.selectLabel"
            :selectedLabel="i18n.multiselect.selectedLabel"
            :deselectLabel="i18n.multiselect.deselectLabel"
            :hide-selected="true"
          >
            <template slot="option" slot-scope="{ option }">
              <div class="option__desc">
                <div class="option__title">
                  <div
                    :class="
                      'relative project-status whitespace-no-wrap text-xs py-1 px-2 status w-32 ' +
                      option.name
                    "
                  >
                    <span class="" v-text="option.label"></span>
                  </div>
                </div>
              </div>
            </template>

            <template slot="tag" slot-scope="{ option, remove }">
              <div class="pr-1 pb-1 inline-block">
                <span
                  :class="
                    'relative project-status whitespace-no-wrap text-xs py-1 px-2 status ' +
                    option.name
                  "
                >
                  <span class="" v-text="option.label"></span>
                  <span class="ml-2">
                    <font-awesome-icon
                      icon="times"
                      size="xs"
                      class="cursor-pointer"
                      @click="remove(option)"
                    ></font-awesome-icon>
                  </span>
                </span>
              </div>
            </template>
          </multiselect>
          <div class="pt-5">
            <input
              type="checkbox"
              id="save_default_projects_filters"
              value="1"
              class="hidden"
              v-model="save_default"
            />
            <label
              for="save_default_projects_filters"
              class="flex items-baseline cursor-pointer"
            >
              <span
                class="flex justify-center items-center w-5 h-5 inline-block mr-3 rounded border border-grey"
              >
                <span class="text-xs">
                  <font-awesome-icon icon="check"></font-awesome-icon>
                </span>
              </span>
              <p class="whitespace-no-wrap" v-html="i18n.save_as_default"></p>
            </label>
          </div>
          <div class="flex justify-between items-center pt-5">
            <button
              class="button action py-1 px-2"
              @click.prevent="applyFilters"
              v-text="i18n.actions.apply"
            ></button>
            <button
              class="button action-secondary py-1 px-2"
              @click="hideFilters"
              v-text="i18n.actions.cancel"
            ></button>
          </div>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";
import Multiselect from "vue-multiselect";

export default {
  props: ["i18n"],
  components: { CollapseTransition, Multiselect },
  mixins: [],
  data() {
    return {
      visible: false,
      save_default: false,
      statusesObj: undefined,
      useSavedFilters: false,
      formStatuses: [],
    };
  },
  methods: {
    toggleFilters() {
      this.visible = !this.visible;
    },

    hideFilters() {
      this.visible = false;
    },

    applyFilters() {
      this.formStatuses = this.getSelectedStatuses();

      if (this.save_default) {
        localStorage.setItem(
          "dashboard_projects_filters",
          JSON.stringify({
            statuses: this.formStatuses,
          })
        );
      } else {
        localStorage.removeItem("dashboard_projects_filters");
      }

      this.setCurrentFilters();

      this.visible = false;
    },

    setCurrentFilters() {
      let filters = {
        statuses: this.formStatuses,
      };

      this.$store.commit("dashboard/setProjectsFilters", filters);

      this.$emit("status-filter-updated", this.formStatuses);
    },

    restoreSavedStatuses() {
      let statuses = this.$store.state.dashboard.projects.statuses;
      this.statusesObj = Object.entries(statuses)
        .map(([name, label]) => ({ name, label }))
        .filter((status) => this.formStatuses.includes(status.name));
    },

    getSelectedStatuses() {
      let statusesObj = this.statusesObj;
      if (statusesObj === undefined) {
        return [];
      }

      let statuses = [];
      statusesObj.forEach((status) => {
        statuses.push(status.name);
      });

      return statuses;
    },
  },
  computed: {
    statuses() {
      return Object.entries(
        this.$store.state.dashboard.projects.statuses
      ).map(([name, label]) => ({ name, label }));
    },
  },
  mounted() {
    let savedFilters = localStorage.getItem("dashboard_projects_filters");

    if (savedFilters) {
      let filters = JSON.parse(savedFilters);
      this.formStatuses = filters.statuses;
      this.restoreSavedStatuses();
      this.useSavedFilters = true;
      this.save_default = true;
      this.setCurrentFilters();
      this.formStatuses = this.getSelectedStatuses();
    }
  },
};
</script>
